import React, { useState, useEffect } from 'react';
import styles from './createPipelineModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import AddPipelineConfigurations from './pipelineConfigurations';
import AddPipelineVacancyConfigurations from './vacancyConfigurations';
import AddPipelineReview from './review';
import { QualificationsAndResponsibilities } from './qualificationsAndResponsibilities';
import AdditionalDetails from './additionaldetails';
import AddReviewCriteria from './reviewCriteria';

export const CreatePipelineModal = (props) => {
    let [step, setStep] = useState(1);
    let [createPipeline, setPipeline] = useState({
        pipeline_name: '',
        hiring_position_label: '',
        qualifications: [],
        responsibilities: [],
        description: '',
        coverLetter: false,
        salaryExpectation: false,
        availableDate: false,
        customQuestions: [],
        jobType: '',
        jobMobility: '',
        location: '',
        paidCurrency: '',
        salaryPaidBy: '',
        reviewCriteria: [
            {
                label: 'Educational qualifications',
            },
            {
                label: 'Professional qualifications',
            },
            {
                label: 'Leadership skills',
            },
            {
                label: 'Communication skills',
            },
            {
                label: 'Work experience',
            }
        ],
    })

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    function setPipelineName(value) {
        setPipeline((prevState) => ({
            ...prevState,
            pipeline_name: value

        }))
    }


    function setPipelineDetails(values) {
        setPipeline((prevState) => ({
            ...prevState,
            hiring_position_label: values.position,
            description: values.vacancyDesc,
            jobType: values.jobType,
            jobMobility: values.jobMobility,
            location: values.location,
            paidCurrency: values.paidCurrency,
            salaryPaidBy: values.salaryPaidBy
        }))
    }



    function setQualificationsAndResponsibilities(values) {
        setPipeline((prevState) => ({
            ...prevState,
            responsibilities: values.responsibilities,
            qualifications: values.qualifications

        }))
    }
    function setAdditionalDetails(values) {
        setPipeline((prevState) => ({
            ...prevState,
            coverLetter: values.coverLetter,
            salaryExpectation: values.salaryExpectation,
            availableDate: values.availableDate,
            customQuestions: values.customQuestions,
        }))
    }
    function setAddReviewCriteria(values) {
        setPipeline((prevState) => ({
            ...prevState,
            reviewCriteria: values.reviewCriteria,
        }))
    }



    useEffect(() => {
        let unmounted = false;
        return () => { unmounted = true };
    }, []);

    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose} id="create_new_pipeline_modal_close_btn">
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Create Pipeline</h2>
                    </div>
                    <Col sm={{ span: 8, offset: 2 }} className={styles.stepPosition}>

                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : step === 3 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv3}` : step === 4 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv4}` : step === 5 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv5}` : step === 6 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv6}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>
                                {
                                    step === 1 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_613_29628)">
                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_613_29628">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                }

                            </div>
                            <div className={(step === 2) || (step === 3) || (step === 4) || (step === 5) || (step === 6) ? styles.stepActive : ''}>
                                {
                                    step === 2 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 2) || (step === 3) || (step === 4) || (step === 5) || (step === 6) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                            <div className={(step === 3) || (step === 4) || (step === 5) || (step === 6) ? styles.stepActive : ''}>
                                {
                                    step === 3 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 3) || (step === 4) || (step === 5) || (step === 6) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                            <div className={(step === 4) || (step === 5) || (step === 6) ? styles.stepActive : ''}>
                                {
                                    step === 4 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 4) || (step === 5) || (step === 6) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                            <div className={(step === 5) || (step === 6) ? styles.stepActive : ''}>
                                {
                                    step === 5 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 5) || (step === 6) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                            <div className={(step === 6) ? styles.stepActive : ''}>
                                {
                                    step === 6 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 6) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <Container className={styles.colWithNoSidePaddings}>
                            <p ><span className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Pipeline Configurations'
                                        : step === 2 || step === 3 ? 'Vacancy Configurations'
                                            : step === 4 ? 'Additional Details'
                                                : step === 5 ? 'Evaluation Criteria' : 'Review'
                                }
                                </span>
                            </p>
                        </Container>
                    </Col>
                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <Container className={styles.colWithNoSidePaddings}>
                            {/* Rendering Content Goes Here */}
                            {step === 1 && props.show === true && <AddPipelineConfigurations nextPage={nextPage} setPipelineName={setPipelineName} pipelineValues={createPipeline} />}
                            {step === 2 && props.show === true && <AddPipelineVacancyConfigurations nextPage={nextPage} previousPage={previousPage} setPipelineDetails={setPipelineDetails} pipelineValues={createPipeline} />}
                            {step === 3 && props.show === true && <QualificationsAndResponsibilities previousPage={previousPage} nextPage={nextPage} setQualificationsAndResponsibilities={setQualificationsAndResponsibilities} pipelineValues={createPipeline} />}
                            {step === 4 && props.show === true && <AdditionalDetails previousPage={previousPage} nextPage={nextPage} setAdditionalDetails={setAdditionalDetails} pipelineValues={createPipeline} />}
                            {step === 5 && props.show === true && <AddReviewCriteria previousPage={previousPage} nextPage={nextPage} setAddReviewCriteria={setAddReviewCriteria} pipelineValues={createPipeline} />}
                            {step === 6 && props.show === true && <AddPipelineReview previousPage={previousPage} pipelineValues={createPipeline} handleClose={props.handleClose} getAllPipelinesValues={props.getAllPipelinesValues} />}
                        </Container>
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}
